import React from "react";
import {useDispatch} from "react-redux";
import {useAppSelector} from "../../app/hooks";
import {setPage} from "../pagination/PaginationSlice";
import {setSearch, searchState, submit} from "./SearchSlice";

interface SearchProps {
  disabled: boolean;
}

const Search = (props: SearchProps) => {
  const state = useAppSelector(searchState);
  const dispatch = useDispatch();

  const onSubmit = (event: React.SyntheticEvent) => {
    dispatch(submit());
    dispatch(setPage(1));
    event.preventDefault();
  };

  return (
    <nav className="navbar navbar-light bg-light d-flex">
      <form className="form-inline w-100" onSubmit={onSubmit}>
        <div className="row">
          <div className="col-11 mr-auto p-2">
            <input
              className="form-control"
              type="search"
              placeholder="Search"
              aria-label="Search"
              value={state.search || ""}
              onChange={(e) => {
                dispatch(setSearch(e.target.value));
              }}
            />
          </div>
          <div className="col-1 p-2">
            <button className="btn btn-outline-success" type="submit" disabled={props.disabled}>
              Search
            </button>
          </div>
        </div>
      </form>
    </nav>
  );
};

export default Search;
